import React from 'react';
import './Chapters.scss';

function Chapter5() {
  return (
    <>
      <section className="chapter" style={{ marginBottom: '-1.5rem' }}>
        <p className="chapter__paragraph">
          “Most folks don’t want video leaving the premises,” Shaw says. That’s especially true in
          Europe, where the GDPR privacy regulation provides strict privacy protections for
          consumers. “And that round trip to the cloud—even if you have a ton of bandwidth
          available—can take a lot of time.”
        </p>
        <p className="chapter__paragraph">
          Among the benefits that edge AI brings Sunlight.io's quick service restaurant clients and
          their customers, for example: better service enabled by advanced computing that’s easy for
          non-specialists to install and maintain. Ready access to such technology opens the door to
          many possibilities, according to Chesterfield. “We're seeing the use of technology to do
          more automation,” he says. “So, things like robotic kitchen automation and natural
          language processing for automated ordering systems.”
        </p>
      </section>
    </>
  );
}

export default Chapter5;
